import React from "react";
import Eyebrow from "./Eyebrow";

const steps = [
  "Needs diagnosis",
  "Custom curriculum",
  "Expert facilitation",
  "Business case projects",
  "Progress reporting",
];

const WhySpotlightSection = () => {
  return (
    <section
      className="grid grid-cols-1 lg:grid-cols-corp-why items-center gap-11 lg:gap-[90px] text-white bg-[#070951] py-[78px] lg:py-[100px] px-[18px] sm:px-[max(26px,50vw-640px)]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 10% 20%, #fbaf1b29, #0000 26%), linear-gradient(#ffffff09 1px, #0000 1px), linear-gradient(90deg, #ffffff09 1px, #0000 1px)",
        backgroundSize: "auto, 64px 64px, 64px 64px",
      }}
    >
      <div>
        <Eyebrow light>WHY UTIVA</Eyebrow>
        <h2 className="text-white tracking-[-0.045em] m-0 text-[36px] font-bold sm:text-corp-h2 leading-[1.12]">
          Practical capability built around real business problems.
        </h2>
        <p className="text-[#d8dfff] mt-6 mb-0 text-[17px] leading-[1.8]">
          Utiva brings faculty, curriculum, delivery infrastructure and
          project-based learning into one workforce transformation plan.
        </p>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-[14px] m-0 p-0 list-none">
        {steps.map((step, index) => (
          <li
            key={step}
            className="flex items-end gap-4 min-h-[112px] p-[23px] text-[17px] font-bold bg-white/[0.055] border border-white/[0.18] rounded-[18px]"
          >
            <span className="text-secondary text-sm font-850">
              {String(index + 1).padStart(2, "0")}
            </span>
            {step}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default WhySpotlightSection;
